<div 
  class="markdown-viewer h4" 
  [class.editable]="editable"
  markdown 
  [data]="data" 
  (click)="onMarkdownClick($event)"
  [attr.contenteditable]="editable ? 'true' : null"
  (input)="onContentInput($event)"
  (blur)="onBlur()"
  (keydown)="onKeyDown($event)">
</div>

@if (popupData(); as pd) {
  <app-wikilink-popup
    [data]="pd"
    (navigate)="onPopupNavigate($event)"
    (create)="onPopupCreate($event)"
    (changed)="onPopupChanged($event)"
    (unlink)="onPopupUnlink($event)"
    (closed)="closePopup()">
  </app-wikilink-popup>
}
